type BrandNameProps = {
  className?: string
}

export default function BrandName({ className = '' }: BrandNameProps) {
  return (
    <span
      aria-label="Ask QIEN"
      className={`font-sans font-bold text-sky-700 dark:text-sky-300 ${className}`.trim()}
    >
      Ask QIEN
    </span>
  )
}
